import React from 'react';
import Button from '@mui/material/Button';

export default function Appbutton({ bgColor, handleAppButton, disabled, children }) {
    return (
        <Button disabled={disabled} variant="contained" sx={{ backgroundColor: bgColor }} onClick={handleAppButton}>{children}</Button>
    )
}
